import Icon from '@material-ui/icons/People';
import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';


export {
  Create,
  Edit,
  Icon,
  List,
  Show,
};



// WEBPACK FOOTER //
// ./src/components/User/index.js